import { render, staticRenderFns } from "./accessRuleConfig.vue?vue&type=template&id=f41f065c&scoped=true"
import script from "./accessRuleConfig.vue?vue&type=script&lang=js"
export * from "./accessRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./accessRuleConfig.vue?vue&type=style&index=0&id=f41f065c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41f065c",
  null
  
)

export default component.exports